<template>
  <el-dialog :title="$t('COMMON_CHANGESTATUS')"
             visible
             @close="onCancel"
             width="40%">
    <el-form ref="form"
             :model="form"
             :rules="rules"
             label-width="120px"
             class="demo-ruleForm">

      <el-form-item :label="$t('PAGE_PBC_CHANGETO')"
                    prop="status">
        <el-select v-model="form.status"
                   style="width:100%"
                   :placeholder="$t('COMMON_SELECT')">
          <el-option v-for="item in statusListFit"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.status=='3'" :label="$t('PAGE_PBC_COMMENTS')"
                    prop="comments">
        <el-input v-model="form.comments"
                  type="textarea"
                  :rows="2"
                  style="width:100%">
        </el-input>
      </el-form-item>
    </el-form>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="cancel-btn">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 @click="onConfirm"
                 class="wl-green">{{$t('btn_save')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                statusListFit: [],
                form: {
                    status: '',
                    comments: ''
                }
            };
        },
        computed: {
            rules() {
                const rules = {
                    status: [{required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'change'}],
                    comments: [{min: 0, max: 400, message: this.$t('FORM_VALIDATE_COMMENTS_MAX'), trigger: 'blur'}]
                }
                return rules
            }
        },
        methods: {
            onConfirm() {
                this.$refs.form.validate(validate => {
                    if (validate) {
                      const params = {
                        chosenList: _.map(this.chosenList, v => v.id),
                        status: this.form.status,
                        comments: this.form.status == '3' ? this.form.comments : ''
                      }
                      // 调整为“已接受”后，该PBC条目将不可再更新
                      if(this.form.status === '4') {
                        this.$confirm(this.$t('PBC_ACCEPT_CONFIRM_MSG'), this.$t('COMMON_TIP'), {
                          confirmButtonText: this.$t('btn_confirm'),
                          cancelButtonText: this.$t('btn_cancel'),
                          type: 'warning'
                        }).then(() => {
                          this.onBatchUpdate(params);
                        }).catch(() => {
                        })
                      } else {
                        this.onBatchUpdate(params);
                      }
                    }
                });
            }
        },
        created() {
            this.statusListFit = []
            this.statusList.forEach((i, n) => {
                if (i.value == '3') {
                    let kv = {value: i.value, label: this.$t('REVISION')}
                    this.statusListFit.push(kv)
                }else if (i.value == '4') {
                    let kv = {value: i.value, label: this.$t('ACCEPTED')}
                    this.statusListFit.push(kv)
                }else if (i.value == '2') {
                  let kv = {value: i.value, label: this.$t('UPLOADED')}
                  this.statusListFit.push(kv)
                }
            })
        },
        props: {
            onCancel: Function,
            statusList: {
                type: Array,
                default: () => []
            },
            chosenList: Array,
            onBatchUpdate: Function
        }
    };
</script>
<style scoped>
</style>
